import React, { useContext, useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { UserContext } from '../../App';
import ServiceList from '../../Pages/ServiceList/ServiceList';
import './SideNavbar.css';

const SideNavbar = ({serviceId}) => {
    const [userInfo, setUserInfo] = useContext(UserContext);
    const [isAdmin, setIsAdmin] = useState (false);
    // checking admin or not 

    useEffect( () =>{
        fetch(`https://damp-fjord-76287.herokuapp.com/isAdmin?email=${userInfo.email}`)
        .then(res => res.json())
        .then(data => {
            console.log(data)
            if(data){
                setIsAdmin(true)
            }
        })
    },[])

    return (
        <div className = 'side-navbar'>
            <nav className=" navbar navbar-light">
                <ul className="navbar-nav ">
                    <li className="nav-item">
                        <NavLink className="" to={`/order/${serviceId}`}>Order</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="" to="/service-list">Service List</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="" to="/review">Review</NavLink>
                    </li>
                    {
                        isAdmin && 
                        <li className="nav-item">
                            <NavLink className="" to="/add-service">Add Service</NavLink>
                        </li>  
                    }
                    {
                        isAdmin && 
                        <li className="nav-item">
                            <NavLink className="" to="/add-admin">Add Admin</NavLink>
                        </li>
                    }
                </ul>
            </nav>
        </div>
    );
};

export default SideNavbar;